import InboxIcon from '@mui/icons-material/Inbox';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useMatch, useNavigate, useResolvedPath } from 'react-router';

const SidebarListItem = ({
  caption = 'Lorem Ipsum',
  icon = <InboxIcon />,
  url = 'home',
}) => {
  const navigate = useNavigate();

  let resolved = useResolvedPath(url);
  let match = useMatch({ path: resolved.pathname, end: true });

  const onClick = (e) => {
    e.preventDefault();
    navigate(url);
  };

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton onClick={(e) => onClick(e)} selected={!!match}>
          <ListItemIcon sx={{ minWidth: 0, pr: 2 }}>{icon}</ListItemIcon>
          <ListItemText primary={caption} />
        </ListItemButton>
      </ListItem>
    </>
  );
};

SidebarListItem.propTypes = {
  caption: PropTypes.string,
  icon: PropTypes.element,
  url: PropTypes.string,
};

SidebarListItem.defaultProps = {};

export { SidebarListItem };
